var toppingIdSelector = function toppingIdSelector() {
  var toppingSelector = document.querySelectorAll('input[name="properties[Topping]"]');
  var toppingInputId = document.querySelector('input[name="additionalToppingId"]');
  if (!toppingInputId) return;
  toppingSelector.forEach(function (selector) {
    selector.addEventListener("change", function () {
      toppingInputId.value = selector.dataset.variant || "";
    });
  });
};
var additionalSelector = function additionalSelector() {
  var nonFoodSelectors = document.querySelectorAll('input[name="properties[Additional]"]');
  var nonFoodInputId = document.querySelector('input[name="additionalProductId"]');
  if (!nonFoodInputId) return;
  nonFoodSelectors.forEach(function (selector) {
    selector.addEventListener("change", function () {
      nonFoodInputId.value = selector.dataset.variant || "";
    });
  });
};

// Reconstruye las opciones de topping para la variante. Si `info` es undefined
// (la talla no tiene toppings con precio) deja solo "None"; antes esto crasheaba
// con TypeError y dejaba congelados los toppings de la talla anterior.
var buildNewOptions = function buildNewOptions(info) {
  var toppingContainer = document.querySelector("#toppingWithPrice");
  var toppingInputId = document.querySelector('input[name="additionalToppingId"]');
  if (!toppingContainer) return;
  if (toppingInputId) toppingInputId.value = "";
  var html = "\n    <legend class=\"required\"> Select a topping for your cake</legend>\n    <input type=\"radio\" name=\"properties[Topping]\" id=\"none_top\" data-variant=\"\" value=\"None\" checked></input>\n    <label for=\"none_top\">None</label>\n  ";
  (info ? info.toppings : []).forEach(function (topping) {
    html += "\n      <input type=\"radio\" name=\"properties[Topping]\" id=\"".concat(info.variant_id, "-").concat(topping.id, "\" data-variant=\"").concat(topping.id, "\" value=\"").concat(topping.title, " (+ ").concat(topping.price, ")\"></input>\n      <label for=\"").concat(info.variant_id, "-").concat(topping.id, "\">").concat(topping.title, " (+").concat(topping.price, ")</label>\n    ");
  });
  toppingContainer.innerHTML = html;
  toppingIdSelector();
};
var renderingToppings = function renderingToppings(title) {
  buildNewOptions(window.variantObject ? window.variantObject[title] : undefined);
};
var toppingChangeVariant = function toppingChangeVariant() {
  document.querySelectorAll('variant-selects input[name="Size"]').forEach(function (selector) {
    selector.addEventListener("change", function () {
      renderingToppings(selector.value);
    });
  });
};
export var toppingWithPriceInit = function toppingWithPriceInit() {
  toppingIdSelector();
  toppingChangeVariant();
  additionalSelector();
};